module.exports = __webpack_public_path__ + "static/media/activities.2def2846.svg";